import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { ActionButton } from 'src/tef/components/buttons/ActionButton';
import { ContainerBox } from 'src/tef/components/primitives/ContainerBox';
import { FlexContainer } from 'src/tef/components/primitives/FlexContainer';
import { TypographyText } from 'src/tef/components/primitives/TypographyText';
import { cn } from 'src/tef/components/utils/cn';

interface PageHeaderProps {
  title: string;
  onBack: () => void;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, onBack, actions, className }) => {
  return (
    <ContainerBox className={cn('mb-8 shrink-0 flex flex-row items-center gap-4', className)}>
      <ActionButton
        type="button"
        variant={{ style: 'ghost', size: 'md' }}
        onClick={onBack}
        icon={<ChevronLeft className="w-5 h-5" />}
        className="shrink-0 hover:bg-slate-100 dark:hover:bg-slate-800"
        aria-label="Back"
      >
        Back
      </ActionButton>
      <TypographyText
        variant={{ type: 'h1', size: '3xl' }}
        className="font-bold bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent"
      >
        {title}
      </TypographyText>
      {actions && (
        <FlexContainer align="center" gap="md" className="ml-auto shrink-0">
          {actions}
        </FlexContainer>
      )}
    </ContainerBox>
  );
};
